// 2026-10-29: the supplier preview screens (Inventory Management > Products / Services, Data Management > My Buyer,
// inventory preview, inbox Email tab) still show hardcoded sample buyers, e-mails and RFQs. They stay hidden from
// suppliers until they are wired to real data; set this to true then. The routes and components are unchanged.
// 2026-10-31: Products and Services now use real data and are always in the menu; this flag still hides My Buyer
// and the inbox Email tab.
export const SUPPLIER_PREVIEW_SCREENS_ENABLED = false;
